export default __webpack_public_path__ + "static/Lavaux-Vineyards-Switzerland-85481751e2b359d90cfa157e122af9ca.jpg";